import {
  Component,
  ContentChild,
  input,
  TemplateRef,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { V3ScrollableContentListController } from '../scrollable-content-list.controller';

/**
 * A container component for both list and button based menus.
 * Provide a template name '#menuItemTemplate' which can receive a ContentListItem named 'menuItem' as follows:
 *       <ng-template #menuItemTemplate let-item="menuItem">...
 * Styling is provided to handle scrolling the container horizontally if either scroll-on-all or scroll-on-mobile are true.
 * If 'is-button-grid' is true, then styling is added to make the container a flex container, and a default gutter is added.
 * You can add additional styling by adding additional classes to the '.pv3-content-list-menu' selector.
 */
@Component({
  selector: 'pv3-content-list-menu',
  templateUrl: 'content-list-menu.component.html',
  styleUrl: 'content-list-menu.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, NgTemplateOutlet],
})
export class V3ContentListMenuComponent extends V3ScrollableContentListController {
  public isButtonGrid = input(false);

  @ContentChild('menuItemTemplate', { descendants: false })
  _menuItemTemplate: TemplateRef<any> | null = null;

  override buildWrapperKlasses(): any[] {
    const klasses = super.buildWrapperKlasses();
    if (this.isButtonGrid()) {
      klasses.push('is-button-grid');
    }
    return klasses;
  }
}
